<template>
<div v-if="loadedUser.props"
	class="user"
	:class="[
		'user-'+loadedUser.props.id,
		{'idle': loadedUser.props.idle},
		{'online': loadedUser.props.online},
		{'offline': !loadedUser.props.online},
		{'lfrp': loadedUser.props.lfrpAdOn},
		{'friend': loadedUser.friendOf},
		{'owner': room && isOwnerOf(room, false, loadedUser)},
		{'mod': room && isModOf(room, false, loadedUser)},
		{'busy': mapToStatusType(loadedUser.props.statusType) === 'Busy'}
	]"
	@mouseover="showMiniProfile" @mouseleave="hideMiniProfile"
>
	<user-image :user="loadedUser" :account="account" :editanddel="editanddel" :animate="false" />
	<div>
		<user-name :user="loadedUser" :account="false" />
		<p v-if="editanddel">
			<a class="no-underline edit-profile"
				target="_blank"
				:href="`//www.rphaven.com/account.php?edit=${loadedUser.props.id}`">✎</a>
			<a v-if="loadedUser.props.animateIcon"
				class="no-underline remove-animation"
				@click="removeAnimation">📺<!--🎞--></a>
			<a class="no-underline delete-char red-text"
				:class="state.deleting ? 'disabled' : ''"
				@click="deleteChar">🗑</a>
		</p>
		<div class="statuses flex-parent">
			<svg v-if="isOwnUser(account, loadedUser)"
				class="a vertical-align-middle"
				xmlns="http://www.w3.org/2000/svg" x="0px" y="0px" width="18"
				height="18" viewBox="0 0 64 64"
				style=" fill:#000000;"
				@click.prevent="contextMenu"
			><path fill="#c2cde7" d="M58.8,26.83l-6.66-1.67a20.47,20.47,0,0,0-1.07-2.55l3.54-5.9a2.9,2.9,0,0,0-.44-3.54L50.84,9.83a2.9,2.9,0,0,0-3.54-.44l-5.9,3.54a20.16,20.16,0,0,0-2.56-1.06L37.17,5.2A2.9,2.9,0,0,0,34.36,3H29.64a2.9,2.9,0,0,0-2.81,2.2l-1.67,6.66a20.39,20.39,0,0,0-2.55,1.07L16.7,9.39a2.9,2.9,0,0,0-3.54.44L9.83,13.16a2.9,2.9,0,0,0-.44,3.54l3.54,5.9a20.24,20.24,0,0,0-1.06,2.56L5.2,26.83A2.9,2.9,0,0,0,3,29.64v4.71a2.9,2.9,0,0,0,2.2,2.81l6.66,1.67a20.47,20.47,0,0,0,1.07,2.55L9.39,47.3a2.9,2.9,0,0,0,.44,3.54l3.33,3.33a2.9,2.9,0,0,0,3.54.44l5.9-3.54a20.16,20.16,0,0,0,2.56,1.06l1.67,6.67A2.9,2.9,0,0,0,29.64,61h4.71a2.9,2.9,0,0,0,2.81-2.2l1.67-6.66a20.39,20.39,0,0,0,2.55-1.07l5.9,3.54a2.89,2.89,0,0,0,3.54-.44l3.33-3.33a2.9,2.9,0,0,0,.44-3.54l-3.54-5.9a20.24,20.24,0,0,0,1.06-2.56l6.67-1.67A2.9,2.9,0,0,0,61,34.36V29.64A2.9,2.9,0,0,0,58.8,26.83Z" /><path fill="#d3dded" d="M52.14 25.16a20.48 20.48 0 0 0-1.07-2.55l3.54-5.9a2.9 2.9 0 0 0-.44-3.54l-.67-.67L12.71 53.29c.62.59 1.26 1.14 1.93 1.67a2.88 2.88 0 0 0 2.06-.35l5.9-3.54a20.16 20.16 0 0 0 2.56 1.06l.74 3L55.1 25.9zM51.51 10.49L51 10H46.28l-.7.42L10.42 45.58l-1 1.72A2.88 2.88 0 0 0 9 48.91a28.27 28.27 0 0 0 1.77 2.32zM38.84 11.86l-.74-3L8.9 38.1l3 .74c.11.31.23.63.36.94L39.78 12.22C39.47 12.09 39.15 12 38.84 11.86z" /><path fill="#acb7d0" d="M32 19A13 13 0 1 0 32 45A13 13 0 1 0 32 19Z" /><path fill="#f9dd8f" d="M32 25A7 7 0 1 0 32 39A7 7 0 1 0 32 25Z" /><path fill="#8d6c9f" d="M45 31H43a1 1 0 0 0 0 2h2a1 1 0 0 0 0-2zM32 42a1 1 0 0 0-1 1v2a1 1 0 0 0 2 0V43A1 1 0 0 0 32 42zM40.49 39.07a1 1 0 0 0-1.41 1.41l1.41 1.41a1 1 0 0 0 1.41-1.41zM39.78 25.22a1 1 0 0 0 .71-.29l1.41-1.41a1 1 0 0 0-1.41-1.41l-1.41 1.41a1 1 0 0 0 .71 1.71zM44.43 35.94l-1.85-.75A1 1 0 1 0 41.82 37l1.85.75a1 1 0 1 0 .75-1.85zM37.22 41.74a1 1 0 1 0-1.84.78l.78 1.84A1 1 0 1 0 38 43.58zM41.21 28.09a1 1 0 0 0 1.31.53l1.84-.78A1 1 0 0 0 43.58 26l-1.84.78A1 1 0 0 0 41.21 28.09z" /><path fill="#8d6c9f" d="M59.73,26.65l-6.89-1.73a21.18,21.18,0,0,0-1.11-2.64l3.66-6.11a3,3,0,0,0-.45-3.67L51.49,9.06a3,3,0,0,0-3.66-.45l-6.11,3.66a20.85,20.85,0,0,0-2.64-1.1l-1.72-6.9A3,3,0,0,0,34.44,2H29.56a3,3,0,0,0-2.91,2.27l-1.73,6.89a21.1,21.1,0,0,0-2.64,1.11L16.18,8.61a3,3,0,0,0-3.66.45L9.06,12.51a3,3,0,0,0-.45,3.67l3.66,6.11a20.94,20.94,0,0,0-1.1,2.65l-6.9,1.72A3,3,0,0,0,2,29.56v4.88a3,3,0,0,0,2.27,2.91l6.89,1.73a21.18,21.18,0,0,0,1.11,2.64L8.61,47.82a3,3,0,0,0,.45,3.67l3.45,3.45a3,3,0,0,0,3.66.45l6.11-3.66a20.85,20.85,0,0,0,2.64,1.1l1.72,6.9A3,3,0,0,0,29.56,62h4.88a3,3,0,0,0,2.91-2.27l1.73-6.89a21.1,21.1,0,0,0,2.64-1.11l6.11,3.66a3,3,0,0,0,3.66-.45l3.45-3.45a3,3,0,0,0,.45-3.67l-3.66-6.11a20.94,20.94,0,0,0,1.1-2.65l6.9-1.72A3,3,0,0,0,62,34.44V29.56A3,3,0,0,0,59.73,26.65ZM60,34.44a1,1,0,0,1-.76,1l-6.9,1.72a2,2,0,0,0-1.4,1.3,19.83,19.83,0,0,1-1,2.4A2,2,0,0,0,50,42.75l3.66,6.11a1,1,0,0,1-.15,1.22l-3.45,3.45a1,1,0,0,1-1.22.15L42.75,50a2,2,0,0,0-1.92-.07,20,20,0,0,1-2.4,1,2,2,0,0,0-1.3,1.4l-1.72,6.9a1,1,0,0,1-1,.76H29.56a1,1,0,0,1-1-.76l-1.72-6.9a2,2,0,0,0-1.3-1.4,20,20,0,0,1-2.4-1,2,2,0,0,0-.9-.21,2,2,0,0,0-1,.28l-6.11,3.66a1,1,0,0,1-1.22-.15l-3.45-3.45a1,1,0,0,1-.15-1.22L14,42.75a2,2,0,0,0,.07-1.92,19.91,19.91,0,0,1-1-2.4,2,2,0,0,0-1.4-1.3l-6.9-1.72a1,1,0,0,1-.76-1V29.56a1,1,0,0,1,.76-1l6.9-1.72a2,2,0,0,0,1.4-1.3,19.83,19.83,0,0,1,1-2.4A2,2,0,0,0,14,21.25l-3.66-6.11a1,1,0,0,1,.15-1.22l3.45-3.45a1,1,0,0,1,1.22-.15L21.25,14a2,2,0,0,0,1.92.07,20,20,0,0,1,2.4-1,2,2,0,0,0,1.3-1.4l1.72-6.9a1,1,0,0,1,1-.76h4.88a1,1,0,0,1,1,.76l1.72,6.9a2,2,0,0,0,1.3,1.4,20,20,0,0,1,2.4,1A2,2,0,0,0,42.75,14l6.11-3.66a1,1,0,0,1,1.22.15l3.45,3.45a1,1,0,0,1,.15,1.22L50,21.25a2,2,0,0,0-.07,1.92,19.91,19.91,0,0,1,1,2.4,2,2,0,0,0,1.4,1.3l6.9,1.72a1,1,0,0,1,.76,1Z" /><path fill="#8d6c9f" d="M32,24a8,8,0,1,0,8,8A8,8,0,0,0,32,24Zm0,14a6,6,0,1,1,6-6A6,6,0,0,1,32,38Z" /><path fill="#8d6c9f" d="M26.39 42.61a12 12 0 0 1 2.74-22.26 1 1 0 1 0-.48-1.94 14 14 0 0 0-3.2 26 1 1 0 0 0 .94-1.77zM33.61 20.11a12 12 0 0 1 2.12.48 1 1 0 0 0 .62-1.9 14 14 0 0 0-2.47-.56 1 1 0 1 0-.26 2zM32 30A2 2 0 1 0 32 34 2 2 0 1 0 32 30z" /><path fill="#fff8f8" d="M32.5 9L33.74 11.26 36 12.5 33.74 13.74 32.5 16 31.26 13.74 29 12.5 31.26 11.26 32.5 9zM18.42 42L19.27 43.56 20.84 44.42 19.27 45.27 18.42 46.84 17.56 45.27 16 44.42 17.56 43.56 18.42 42zM46.35 19L46.94 20.07 48 20.65 46.94 21.23 46.35 22.3 45.77 21.23 44.7 20.65 45.77 20.07 46.35 19z" />
			</svg>
			<span v-if="room" class="icon owner vertical-align-middle" title="Room Owner" />
			<span v-if="room" class="icon mod vertical-align-middle" title="Room Moderator" />
			<span class="icon busy vertical-align-middle" title="Busy" />
			<span class="icon lfrp vertical-align-middle" title="Looking for RP" />
			<span v-if="!isOwnUser(account, loadedUser)"
				class="statusMsg"
				type="input"
				:title="loadedUser.props.statusMsg"
				v-html="parsedStatus" />
			<span v-else
				v-show="!state.hovered"
				class="status statusMsg"
				type="input"
				:title="loadedUser.props.statusMsg"
				v-html="parsedStatus" />
			<psuedo-textarea v-if="isOwnUser(account, loadedUser)"
				v-show="state.hovered"
				class="vanishing"
				type="input"
				placeholder="Set a status message"
				:value="loadedUser.props.statusMsg"
				@keyup.enter.prevent="submitStatus" />
		</div>
		<div v-if="loadedUser.friendOf" class="friend-of"
			:title="loadedUser.friendOf.props.vanity ? loadedUser.friendOf.props.name : undefined"
			:class="[
				'user-'+loadedUser.friendOf.props.id
			]">
			Friend of: {{ loadedUser.friendOf.props.name }}
		</div>
	</div>
	<div class="background-cover" :style="{ background: 'url('+imgUrl+')'}" />
</div>
<div v-else>
	Loading user...
</div>
</template>

<script>
import socket from '../js/socket.js'
import accountFns from '../js/account-functions.js'
import account from '../js/account.js'
import UserImage from './user-image.vue'
import UserName from './user-name.vue'
import PsuedoTextarea from './psuedo-textarea.vue'
import { mapToStatusType, imgUrl, getUserById } from '../js/user-functions.js'
import { isModOf, isOwnerOf } from '../js/room-functions.js'
import anchorme from 'anchorme'
import miniProfileHandler from '../js/mini-profile-handler.js'
import { reactive, ref } from 'vue'

export default {
	components: {
		UserImage,
		UserName,
		PsuedoTextarea
	},
	props: {
		user: {
			type: [Number, Object],
			required: true
		},
		editanddel: {
			type: Boolean
		},
		room: {
			type: [Object, Boolean],
			default: false
		}
	},
	setup( props ){
		const userProp = props.user,
			loadedUser = ref( props.user )
		if( typeof userProp !== 'object' ){
			getUserById( userProp, ( user ) => {
				console.log( 'loaded userline user', user )
				loadedUser.value = user
			})
		}
		return {
			state: reactive({
				hovered: false,
				deleting: false
			}),
			account,
			loadedUser
		}
	},
	computed: {
		imgUrl(){
			return imgUrl( this.loadedUser )
		},
		parsedStatus(){
			let status = this.loadedUser.props.statusMsg

			status = status.replace( /</g, '&lt;' )
			status = status.replace( />/g, '&gt;' )

			let url = anchorme( status, {
				exclude: ( urlObj ) => {
					urlObj.encoded = urlObj.encoded.replace( /%25/g, '%' )
					return false
				},
				list: true
			})
			if( url[0] ){
				status = status.replace( url[0].raw, '' ).trim()
				if( url[0].raw.indexOf( url[0].protocol ) === -1 ){
					url = url[0].protocol + url[0].raw
				} else {
					url = url[0].raw
				}
				status = '<a href="' + url + '" target="_blank">' + status + '</a>'
			}
			return '<span>' + status + '</span>'
		}
	},
	methods: {
		isOwnUser: accountFns.isOwnUser,
		isOwnerOf: isOwnerOf,
		isModOf: isModOf,
		mapToStatusType: mapToStatusType,
		contextMenu( ev ){
			userContextMenu( $( ev.target ), this.loadedUser, ev )
		},
		submitStatus( ev ){
			socket.emit( 'modify', {
				userid: this.loadedUser.props.id,
				statusMsg: ev.target.value//,
				// statusType:type
			})
		},
		deleteChar(){
			if( !this.state.deleting ){
				this.state.deleting = true
				socket.emit( 'delete-char', {userid: this.loadedUser.props.id, username: this.loadedUser.props.name})
			}
		},
		removeAnimation(){
			socket.emit( 'remove-animation', {userid: this.loadedUser.props.id})
		},
		showMiniProfile( ev ){
			this.state.hovered = true
			miniProfileHandler.show( this.loadedUser, ev )
		},
		hideMiniProfile( ev ){
			this.state.hovered = false
			miniProfileHandler.hide( ev )
		}
	}
}
</script>
<style>
	.user {
		position: relative;
		overflow: hidden;
	}
	.user > .background-cover {
		background-position: center center;
		background-size: cover;
		filter: blur(2em);
		position: absolute;
		z-index: -1;
		height: auto;
		top: -1em;
		bottom: -1em;
		left: -1em;
		right: -1em;
		transition: opacity 150ms;
		opacity: 0;
	}
	.user:hover > .background-cover {
		opacity: 0.2;
	}
</style>